Vue       = require('vue/dist/vue')
$eventBus = null

module.exports =

  EventBus:
    get: -> $eventBus

  VuePopups:
    install: (Vue, options = {}) ->
      $eventBus = new Vue()

      Object.defineProperty(Vue.prototype, '$popups', {
        get: -> $eventBus
      })

      null


// WEBPACK FOOTER //
// ./assets/js/shared/plugins/popups/index.coffee